module.exports = "/images/sidebar-4.jpg?3b7e38ed4b9098a9ebcf977acec342eb";